import { IS_PROD } from './env';

export const DOMAIN = IS_PROD
  ? typeof window !== 'undefined'
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).domain
    : null
  : process.env.NEXT_PUBLIC_COMPANY_DOMAIN;

export const AUTH_DOMAIN = `auth.${DOMAIN}`;
export const PAYMENTS_API_URL = IS_PROD
  ? process.env.APP === 'account'
    ? `https://api.${DOMAIN}`
    : `https://api.${DOMAIN}`
  : process.env.NEXT_PUBLIC_PAYMENTS_API_URL;

export const TRADERS_API_URL = IS_PROD
  ? `https://api-trader3.${DOMAIN}`
  : process.env.NEXT_PUBLIC_TRADERS_API_URL ?? '';

export const TRADERS_WEBSOCKET_URL = IS_PROD
  ? `wss://ws-trader.${DOMAIN}`
  : process.env.NEXT_PUBLIC_TRADERS_WEBSOCKET_URL ?? '';
